import React from 'react';
import { Outlet } from 'react-router-dom';

const ParentLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default ParentLayout